import { ApiKy } from './index'
import { GetEmailLogsParams, GetEmailLogsResponse } from '~/types/email-logs'

export default class Api extends ApiKy {
  getEmailLogs(params: GetEmailLogsParams = {}) {
    return this.ky
      .get(this.url, { searchParams: params })
      .json<GetEmailLogsResponse>()
  }
}
